import { render, staticRenderFns } from "./AddQuiz_v2.vue?vue&type=template&id=e57dc240&scoped=true&"
import script from "./AddQuiz_v2.vue?vue&type=script&lang=js&"
export * from "./AddQuiz_v2.vue?vue&type=script&lang=js&"
import style0 from "./AddQuiz_v2.vue?vue&type=style&index=0&id=e57dc240&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57dc240",
  null
  
)

export default component.exports